import axios from "axios";
import { Message } from "element-ui";
import router from './router/index'

let Axios = axios.create({
  // timeout: 120000
});

Axios.defaults.baseURL = 'https://api.smart-speech.com/docs';

Axios.defaults.headers.post["Content-Type"] =
  "application/json,charset=UTF-8;multipart/form-data";

window._axiosPromiseArr = []
// 请求拦截器
Axios.interceptors.request.use(
  config => {
    config.cancelToken = new axios.CancelToken(cancel => {
      window._axiosPromiseArr.push({ cancel })
    })
    return config;
  },
  error => {
    return Promise.error(error);
  }
);

// 响应拦截器
Axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          Message.error({
            message: error.response.data.message,
            duration: 2000,
            onClose: () => {
              router.push('/')
            }
          });
          break;
        case 404:
          Message.error("网络请求不存在");
          break;
        default:
          Message.error(error.response.data.message);
      }
      return Promise.reject(error.response);
    } else {
      Message.error({
        message: '请求失败，请稍后再试',
        duration: 2000,
        onClose: () => {
          router.push('/')
        }
      });
      return Promise.reject(error);
    }
  }
);

export default Axios;
